import store from '@/state/store'
import starlingApi from '@/services/starlingService'

export async function fetchStarlingData () {
  const { data: business } = await starlingApi.get('/account-holder/business')
  if (business.companyRegistrationNumber) store.commit('updateBusinessNumber', business.companyRegistrationNumber)
  if (business.companyName) store.commit('updateBusinessName', business.companyName)

  const { data: individual } = await starlingApi.get('/identity/individual')
  if (individual.firstName) store.commit('updateFirstName', individual.firstName)
  if (individual.lastName) store.commit('updateLastName', individual.lastName)
  if (individual.phone) store.commit('updatePhone', individual.phone)
  if (individual.email) store.commit('updateEmail', individual.email)
}
